<div class="panel dns-panel">
    <div class="panel-content dns-content">
        <p class="dns-hint">
            <i class="fa fa-copy"></i>
            Dati della pratica in sola lettura: clicca sull'icona accanto a ciascun valore per copiarlo. I campi vuoti non hanno un dato corrispondente nella pratica.
        </p>

        <!-- Dati banca/intermediario finanziario + Punto 1 -->
        <section class="dns-section">
            <h3 class="dns-title">Dati banca/intermediario finanziario</h3>
            <div class="dns-grid">
                <div class="dns-field">
                    <label class="dns-label">Denominazione</label>
                    <app-copy-field [value]="request?.LeasingCompanyName"></app-copy-field>
                </div>
                <div class="dns-field">
                    <label class="dns-label">PEC istituto</label>
                    <app-copy-field></app-copy-field>
                </div>
            </div>
        </section>

        <section class="dns-section">
            <h3 class="dns-title">1. Dati identificativi dell'impresa richiedente</h3>
            <div class="dns-alert dns-alert-info">
                Se si tratta di un'azienda italiana iscritta al Registro Imprese, compila il CF e clicca su "Recupera Dati" per compilare l'anagrafica in automatico
            </div>
            <div class="dns-grid">
                <div class="dns-field">
                    <label class="dns-label">Codice fiscale</label>
                    <app-copy-field [value]="customer?.FiscalCode"></app-copy-field>
                </div>
                <div class="dns-field">
                    <label class="dns-label">Partita IVA</label>
                    <app-copy-field [value]="customer?.VATNumber"></app-copy-field>
                </div>
                <div class="dns-field dns-field-spacer"></div>
                <div class="dns-field">
                    <label class="dns-label">Denominazione azienda</label>
                    <app-copy-field [value]="customer?.CompanyName"></app-copy-field>
                </div>
                <div class="dns-field">
                    <label class="dns-label">Forma giuridica</label>
                    <app-copy-field [value]="customer?.LegalForm"></app-copy-field>
                </div>
                <div class="dns-field">
                    <label class="dns-label">PEC <em>(come risultante dal Registro Imprese)</em> <i class="fa fa-info-circle dns-info"></i></label>
                    <app-copy-field [value]="customer?.PEC"></app-copy-field>
                </div>
            </div>
            <div class="dns-alert dns-alert-warning">
                Una volta ottenuta la delibera della domanda da parte dell'istituto bancario, gli utenti indicati ai punti 2 e 3 saranno abilitati ad accedere e gestire le domande dell'impresa tramite SPID/CNS/CIE.
            </div>
        </section>

        <!-- Punto 2 -->
        <section class="dns-section">
            <h3 class="dns-title">2. Dati relativi al firmatario della domanda</h3>
            <div class="dns-grid">
                <div class="dns-field">
                    <label class="dns-label">In qualità di</label>
                    <app-copy-field></app-copy-field>
                </div>
                <div class="dns-field">
                    <label class="dns-label">Data atto procura</label>
                    <app-copy-field></app-copy-field>
                </div>
                <div class="dns-field dns-field-spacer"></div>

                <div class="dns-field">
                    <label class="dns-label">Nome</label>
                    <app-copy-field [value]="customer?.Name"></app-copy-field>
                </div>
                <div class="dns-field">
                    <label class="dns-label">Cognome</label>
                    <app-copy-field [value]="customer?.Surname"></app-copy-field>
                </div>
                <div class="dns-field">
                    <label class="dns-label">Codice fiscale</label>
                    <app-copy-field [value]="signatoryFiscalCode"></app-copy-field>
                </div>

                <div class="dns-field">
                    <label class="dns-label">Data di nascita</label>
                    <app-copy-field [value]="date(customer?.BirthDate)"></app-copy-field>
                </div>
                <div class="dns-field">
                    <label class="dns-label">Stato di nascita</label>
                    <app-copy-field [value]="birthCountry"></app-copy-field>
                </div>
                <div class="dns-field">
                    <label class="dns-label">Provincia di nascita</label>
                    <app-copy-field [value]="customer?.BirthPlaceProvince"></app-copy-field>
                </div>

                <div class="dns-field">
                    <label class="dns-label">Comune di nascita</label>
                    <app-copy-field [value]="customer?.BirthPlace"></app-copy-field>
                </div>
                <div class="dns-field dns-field-spacer"></div>
                <div class="dns-field dns-field-spacer"></div>

                <div class="dns-field">
                    <label class="dns-label">Tipo documento</label>
                    <app-copy-field></app-copy-field>
                </div>
                <div class="dns-field">
                    <label class="dns-label">N° documento</label>
                    <app-copy-field></app-copy-field>
                </div>
            </div>
        </section>

        <!-- Punti 3 e 4 -->
        <section class="dns-section">
            <h3 class="dns-title">3. Dati relativi ad altro soggetto autorizzato all'accesso in piattaforma tramite SPID/CNS/CIE</h3>
            <div class="dns-alert dns-alert-info">Compilare con un soggetto diverso dal firmatario della domanda</div>
            <div class="dns-grid">
                <div class="dns-field">
                    <label class="dns-label">Nome</label>
                    <app-copy-field></app-copy-field>
                </div>
                <div class="dns-field">
                    <label class="dns-label">Cognome</label>
                    <app-copy-field></app-copy-field>
                </div>
                <div class="dns-field">
                    <label class="dns-label">Codice fiscale</label>
                    <app-copy-field></app-copy-field>
                </div>
            </div>
        </section>

        <section class="dns-section">
            <h3 class="dns-title">4. Referente da contattare per eventuali comunicazioni</h3>
            <div class="dns-grid">
                <div class="dns-field">
                    <label class="dns-label">Nome</label>
                    <app-copy-field [value]="customer?.Name"></app-copy-field>
                </div>
                <div class="dns-field">
                    <label class="dns-label">Cognome</label>
                    <app-copy-field [value]="customer?.Surname"></app-copy-field>
                </div>
                <div class="dns-field">
                    <label class="dns-label">In qualità di</label>
                    <app-copy-field [value]="contactRole"></app-copy-field>
                </div>
                <div class="dns-field">
                    <label class="dns-label">Telefono</label>
                    <app-copy-field [value]="customer?.Phone"></app-copy-field>
                </div>
                <div class="dns-field">
                    <label class="dns-label">Cellulare</label>
                    <app-copy-field [value]="customer?.MobilePhone"></app-copy-field>
                </div>
                <div class="dns-field">
                    <label class="dns-label">Email</label>
                    <app-copy-field [value]="customerEmail"></app-copy-field>
                </div>
            </div>
        </section>

        <!-- Punti 5 e 6 -->
        <section class="dns-section">
            <h3 class="dns-title">5. Sede legale</h3>
            <div class="dns-grid">
                <div class="dns-field">
                    <label class="dns-label">Stato</label>
                    <app-copy-field [value]="country"></app-copy-field>
                </div>
                <div class="dns-field">
                    <label class="dns-label">Provincia</label>
                    <app-copy-field [value]="customer?.HeadOfficeProvince"></app-copy-field>
                </div>
                <div class="dns-field">
                    <label class="dns-label">Comune</label>
                    <app-copy-field [value]="customer?.HeadOffice"></app-copy-field>
                </div>
                <div class="dns-field">
                    <label class="dns-label">CAP</label>
                    <app-copy-field></app-copy-field>
                </div>
                <div class="dns-field">
                    <label class="dns-label">Indirizzo</label>
                    <app-copy-field [value]="street(customer?.Address, customer?.HouseNumber)"></app-copy-field>
                </div>
                <div class="dns-field">
                    <label class="dns-label">Telefono</label>
                    <app-copy-field [value]="customer?.Phone"></app-copy-field>
                </div>
            </div>
        </section>

        <section class="dns-section">
            <h3 class="dns-title">6. Unità locale nella quale verrà realizzato l'investimento</h3>
            <div class="dns-grid">
                <div class="dns-field">
                    <label class="dns-label">Stato</label>
                    <app-copy-field [value]="country"></app-copy-field>
                </div>
                <div class="dns-field">
                    <label class="dns-label">Provincia</label>
                    <app-copy-field [value]="request?.OperationalHeadquartersProvince"></app-copy-field>
                </div>
                <div class="dns-field">
                    <label class="dns-label">Comune</label>
                    <app-copy-field [value]="request?.OperationalHeadquarters"></app-copy-field>
                </div>
                <div class="dns-field">
                    <label class="dns-label">CAP</label>
                    <app-copy-field></app-copy-field>
                </div>
                <div class="dns-field">
                    <label class="dns-label">Indirizzo</label>
                    <app-copy-field [value]="street(request?.OperationalHeadquartersAddress, request?.OperationalHeadquartersHouseNumber)"></app-copy-field>
                </div>
                <div class="dns-field">
                    <label class="dns-label">Telefono</label>
                    <app-copy-field [value]="localUnitPhone"></app-copy-field>
                </div>
            </div>
        </section>

        <!-- Punto 7 -->
        <section class="dns-section">
            <h3 class="dns-title">7. Altri dati relativi all'impresa</h3>
            <div class="dns-grid">
                <div class="dns-field">
                    <label class="dns-label">Dimensione di impresa <i class="fa fa-info-circle dns-info"></i></label>
                    <app-copy-field></app-copy-field>
                </div>
                <div class="dns-field">
                    <label class="dns-label">Settore di attività economica</label>
                    <app-copy-field></app-copy-field>
                </div>
                <div class="dns-field">
                    <label class="dns-label">Codice attività ATECO 2025 <i class="fa fa-info-circle dns-info"></i></label>
                    <app-copy-field [value]="atecoCode"></app-copy-field>
                </div>
            </div>

            <h4 class="dns-subtitle">Iscrizione al Registro delle imprese</h4>
            <div class="dns-grid">
                <div class="dns-field">
                    <label class="dns-label">Comune</label>
                    <app-copy-field></app-copy-field>
                </div>
                <div class="dns-field">
                    <label class="dns-label">Numero iscrizione</label>
                    <app-copy-field [value]="customer?.REANumber"></app-copy-field>
                </div>
                <div class="dns-field">
                    <label class="dns-label">Data iscrizione</label>
                    <app-copy-field [value]="date(customer?.RegistrationDate)" emptyText="gg/mm/aaaa"></app-copy-field>
                </div>
            </div>

            <h4 class="dns-subtitle">Dati bancari</h4>
            <div class="dns-grid">
                <div class="dns-field">
                    <label class="dns-label">IBAN</label>
                    <app-copy-field [value]="customer?.IBAN"></app-copy-field>
                </div>
                <div class="dns-field">
                    <label class="dns-label">BIC</label>
                    <app-copy-field [value]="customer?.SupportBankBIC"></app-copy-field>
                </div>
                <div class="dns-field">
                    <label class="dns-label">Banca</label>
                    <app-copy-field [value]="customer?.SupportBankName"></app-copy-field>
                </div>
                <div class="dns-field">
                    <label class="dns-label">Intestatario conto corrente</label>
                    <app-copy-field [value]="customer?.CompanyName"></app-copy-field>
                </div>
            </div>
        </section>

        <!-- Punto 8.1 -->
        <section class="dns-section">
            <h3 class="dns-title">8. Descrizione dell'investimento</h3>

            <div class="dns-card">
                <h4 class="dns-card-title">Spese per investimenti in beni strumentali (tabella A)</h4>
                <div class="dns-alert dns-alert-info">
                    Per B I 3, 4 e B II 2, 3 e 4 si intendono le rispettive voci dello stato patrimoniale, secondo la classificazione prevista dal codice civile
                </div>
                <div class="dns-lines dns-lines-striped">
                    <div class="dns-line dns-line-caption">
                        <div class="dns-line-label"><em>Investimenti in beni strumentali</em> (IVA esclusa)</div>
                    </div>
                    <div class="dns-line dns-line-head">
                        <div class="dns-line-label">Tipologia</div>
                        <div class="dns-line-value">Euro</div>
                    </div>
                    <div class="dns-line">
                        <div class="dns-line-label">B I 3 Diritti di brevetto industriale e di utilizzazione delle opere dell'ingegno</div>
                        <div class="dns-line-value"><app-copy-field></app-copy-field></div>
                    </div>
                    <div class="dns-line">
                        <div class="dns-line-label">B I 4 Concessioni, licenze marchi e diritti simili</div>
                        <div class="dns-line-value"><app-copy-field></app-copy-field></div>
                    </div>
                    <div class="dns-line">
                        <div class="dns-line-label">B II 2 Macchinari e impianti</div>
                        <div class="dns-line-value"><app-copy-field></app-copy-field></div>
                    </div>
                    <div class="dns-line">
                        <div class="dns-line-label">B II 3 Attrezzature e altri beni strumentali di impresa</div>
                        <div class="dns-line-value"><app-copy-field></app-copy-field></div>
                    </div>
                    <div class="dns-line">
                        <div class="dns-line-label">B II 4 Altri beni</div>
                        <div class="dns-line-value"><app-copy-field></app-copy-field></div>
                    </div>
                    <div class="dns-line">
                        <div class="dns-line-label">Totale</div>
                        <div class="dns-line-value">
                            <app-copy-field [value]="categoryDisplay('Ordinario')" [copyText]="categoryCopy('Ordinario')"></app-copy-field>
                        </div>
                    </div>
                </div>
            </div>

            <div class="dns-card">
                <h4 class="dns-card-title">Spese per investimenti 4.0 <i class="fa fa-info-circle dns-info"></i> (tabella B)</h4>
                <div class="dns-lines dns-lines-striped">
                    <div class="dns-line dns-line-caption">
                        <div class="dns-line-label"><em>Investimenti 4.0</em> (IVA esclusa)</div>
                    </div>
                    <div class="dns-line dns-line-head">
                        <div class="dns-line-label">Tipologia</div>
                        <div class="dns-line-value">Euro</div>
                    </div>
                    <div class="dns-line">
                        <div class="dns-line-label">Immobilizzazioni materiali <em>(di cui all'allegato A alla legge 232/2016)</em></div>
                        <div class="dns-line-value"><app-copy-field></app-copy-field></div>
                    </div>
                    <div class="dns-line">
                        <div class="dns-line-label">Immobilizzazioni immateriali <em>(di cui all'allegato B alla legge 232/2016)</em></div>
                        <div class="dns-line-value"><app-copy-field></app-copy-field></div>
                    </div>
                    <div class="dns-line">
                        <div class="dns-line-label">Totale</div>
                        <div class="dns-line-value">
                            <app-copy-field [value]="categoryDisplay('4.0')" [copyText]="categoryCopy('4.0')"></app-copy-field>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Punto 8.2 -->
            <div class="dns-card">
                <h4 class="dns-card-title">Spese per investimenti green <i class="fa fa-info-circle dns-info"></i> (tabella C)</h4>
                <div class="dns-lines dns-lines-striped">
                    <div class="dns-line dns-line-caption">
                        <div class="dns-line-label"><em>Investimenti green</em> (IVA esclusa)</div>
                    </div>
                    <div class="dns-line dns-line-head">
                        <div class="dns-line-label">Tipologia</div>
                        <div class="dns-line-value">Euro</div>
                    </div>
                    <div class="dns-line">
                        <div class="dns-line-label">BII 2 Macchinari e impianti</div>
                        <div class="dns-line-value"><app-copy-field></app-copy-field></div>
                    </div>
                    <div class="dns-line">
                        <div class="dns-line-label">BII 3 Attrezzature e altri beni strumentali di impresa</div>
                        <div class="dns-line-value"><app-copy-field></app-copy-field></div>
                    </div>
                    <div class="dns-line">
                        <div class="dns-line-label">B II 4 Altri beni</div>
                        <div class="dns-line-value"><app-copy-field></app-copy-field></div>
                    </div>
                    <div class="dns-line">
                        <div class="dns-line-label">Totale</div>
                        <div class="dns-line-value">
                            <app-copy-field [value]="categoryDisplay('Green')" [copyText]="categoryCopy('Green')"></app-copy-field>
                        </div>
                    </div>
                </div>
            </div>

            <div class="dns-alert dns-alert-warning">
                Gli importi complessivi sottostanti sono calcolati in automatico compilando le tabelle A, B e C
            </div>

            <div class="dns-lines">
                <div class="dns-line">
                    <div class="dns-line-label"><strong>Importo complessivo dell'investimento</strong> <i class="fa fa-info-circle dns-info"></i>. IVA esclusa pari a €</div>
                    <div class="dns-line-value">
                        <app-copy-field [value]="investmentTotalDisplay" [copyText]="investmentTotalCopy"></app-copy-field>
                    </div>
                </div>
                <div class="dns-line dns-line-caption dns-line-center">
                    <div class="dns-line-label">di cui:</div>
                </div>
                <div class="dns-line">
                    <div class="dns-line-label"><em>investimenti in beni strumentali</em> (totale tabella A), pari a €</div>
                    <div class="dns-line-value">
                        <app-copy-field [value]="categoryDisplay('Ordinario')" [copyText]="categoryCopy('Ordinario')"></app-copy-field>
                    </div>
                </div>
                <div class="dns-line">
                    <div class="dns-line-label"><em>investimenti 4.0</em> (totale tabella B), pari a €</div>
                    <div class="dns-line-value">
                        <app-copy-field [value]="categoryDisplay('4.0')" [copyText]="categoryCopy('4.0')"></app-copy-field>
                    </div>
                </div>
                <div class="dns-line">
                    <div class="dns-line-label"><em>investimenti green</em> (totale tabella C), pari a €</div>
                    <div class="dns-line-value">
                        <app-copy-field [value]="categoryDisplay('Green')" [copyText]="categoryCopy('Green')"></app-copy-field>
                    </div>
                </div>
            </div>
        </section>

        <!-- Punto 9 -->
        <section class="dns-section">
            <h3 class="dns-title">9. Caratteristiche del finanziamento richiesto</h3>
            <div class="dns-lines">
                <div class="dns-line">
                    <div class="dns-line-label"><strong>Importo del finanziamento <em>(min 20.000 euro, max 4 milioni di euro)</em></strong></div>
                    <div class="dns-line-value">
                        <app-copy-field [value]="investmentTotalDisplay" [copyText]="investmentTotalCopy"></app-copy-field>
                    </div>
                </div>
                <div class="dns-line dns-line-caption dns-line-center">
                    <div class="dns-line-label">di cui:</div>
                </div>
                <div class="dns-line">
                    <div class="dns-line-label">per <em>investimenti in beni strumentali</em> €</div>
                    <div class="dns-line-value">
                        <app-copy-field [value]="categoryDisplay('Ordinario')" [copyText]="categoryCopy('Ordinario')"></app-copy-field>
                    </div>
                </div>
                <div class="dns-line">
                    <div class="dns-line-label">per <em>investimenti 4.0</em> <i class="fa fa-info-circle dns-info"></i>€</div>
                    <div class="dns-line-value">
                        <app-copy-field [value]="categoryDisplay('4.0')" [copyText]="categoryCopy('4.0')"></app-copy-field>
                    </div>
                </div>
                <div class="dns-line">
                    <div class="dns-line-label">per <em>investimenti green</em> <i class="fa fa-info-circle dns-info"></i>€</div>
                    <div class="dns-line-value">
                        <app-copy-field [value]="categoryDisplay('Green')" [copyText]="categoryCopy('Green')"></app-copy-field>
                    </div>
                </div>
            </div>

            <div class="dns-grid dns-grid-2 dns-financing">
                <div class="dns-field">
                    <label class="dns-label">Tipologia del finanziamento</label>
                    <div class="dns-radio-list">
                        <div class="dns-option"><span class="dns-radio" [class.dns-checked]="isBankFinancing"></span>bancario</div>
                        <div class="dns-option"><span class="dns-radio" [class.dns-checked]="isLeasing"></span>in leasing</div>
                    </div>
                </div>
                <div class="dns-field">
                    <label class="dns-label">Durata del finanziamento</label>
                    <app-copy-field [value]="financingDuration"></app-copy-field>
                </div>
            </div>
        </section>

        <!-- Punto 10 -->
        <section class="dns-section">
            <h3 class="dns-title dns-title-center dns-title-caps">Dichiara altresì</h3>

            <div class="dns-option dns-option-top">
                <span class="dns-radio" [class.dns-checked]="hasNoOtherConcessions"></span>
                <span>che l'impresa non ha richiesto e/o ottenuto, a fronte dei beni oggetto dell'investimento di cui alla presente domanda, altre agevolazioni di qualsiasi natura previste da norme statali, regionali, comunitarie o comunque concesse da istituzioni o enti pubblici, incluse quelle a titolo di <em>de minimis</em>;</span>
            </div>

            <div class="dns-or">Oppure</div>

            <div class="dns-option dns-option-top">
                <span class="dns-radio"></span>
                <span>che l'impresa ha richiesto, ma non ottenuto, a fronte dei beni oggetto dell'investimento di cui alla presente domanda, altre agevolazioni, incluse quelle a titolo di <em>de minimis</em>, per gli importi indicati nella seguente tabella:</span>
            </div>
            <div class="dns-table-wrap">
                <table class="dns-table">
                    <thead>
                    <tr>
                        <th>Tipologia bene oggetto di richiesta di altre agevolazioni</th>
                        <th>Importo del relativo investimento</th>
                        <th>Legge / Strumento / Intervento</th>
                        <th>Intensità di aiuto (ESL) massima applicabile <i class="fa fa-info-circle dns-info"></i></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngFor="let row of [1, 2, 3]">
                        <td><app-copy-field emptyText="-- selezionare un'opzione --"></app-copy-field></td>
                        <td><app-copy-field></app-copy-field></td>
                        <td><app-copy-field></app-copy-field></td>
                        <td><app-copy-field></app-copy-field></td>
                    </tr>
                    </tbody>
                </table>
            </div>

            <div class="dns-or">Oppure</div>

            <div class="dns-option dns-option-top">
                <span class="dns-radio"></span>
                <span>che, a fronte dei beni oggetto del presente investimento, per il quale si conferma che alla data di inoltro della presente istanza non è stato dato avvio, è stata assegnataria delle seguenti agevolazioni alla medesima data di inoltro della presente istanza per gli importi indicati nella seguente tabella:</span>
            </div>
            <div class="dns-table-wrap">
                <table class="dns-table">
                    <thead>
                    <tr>
                        <th>Tipologia bene agevolato</th>
                        <th>Importo del relativo investimento</th>
                        <th>Legge / Strumento / Intervento</th>
                        <th>Data e numero decreto di concessione</th>
                        <th>Importo concesso</th>
                        <th>ESL relativo (%) <i class="fa fa-info-circle dns-info"></i></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngFor="let row of [1, 2, 3]">
                        <td><app-copy-field emptyText="-- selezionare un'opzione --"></app-copy-field></td>
                        <td><app-copy-field></app-copy-field></td>
                        <td><app-copy-field></app-copy-field></td>
                        <td class="dns-cell-stack">
                            <app-copy-field emptyText="gg/mm/aaaa"></app-copy-field>
                            <app-copy-field></app-copy-field>
                        </td>
                        <td><app-copy-field></app-copy-field></td>
                        <td class="dns-cell-stack">
                            <app-copy-field emptyText="% applicata"></app-copy-field>
                            <app-copy-field emptyText="% massima appl"></app-copy-field>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>

            <div class="dns-alert dns-alert-info dns-concessions-note" *ngIf="hasOtherConcessions">
                <strong>Agevolazioni dichiarate nella pratica</strong>
                <app-copy-field [value]="request?.ConcessionsDetails" emptyText="Nessun dettaglio indicato" [multiline]="true"></app-copy-field>
            </div>
        </section>

        <!-- Punto 11 -->
        <section class="dns-section">
            <div class="dns-option dns-option-top">
                <span class="dns-radio"></span>
                <span>possiede i requisiti, come definiti dalla raccomandazione 2003/361/CE del 6 maggio 2003, pubblicata nella G.U.U.E. n. L 124 del 20 maggio 2003, nell'allegato 1 al <em>regolamento ABER</em> e nel DM 18 aprile 2005, pubblicato nella G.U.R.I. n. 238 del 12 ottobre 2005, di:</span>
            </div>
            <div class="dns-option dns-option-top">
                <span class="dns-radio"></span>
                <span>possiede i requisiti, come definiti dalla raccomandazione 2003/361/CE del 6 maggio 2003, pubblicata nella G.U.U.E. n. L 124 del 20 maggio 2003, nell'allegato 1 al <em>regolamento FIBER</em> e nel DM 18 aprile 2005, pubblicato nella G.U.R.I. n. 238 del 12 ottobre 2005, di:</span>
            </div>
            <div class="dns-option dns-option-top">
                <span class="dns-radio"></span>
                <span>possiede i requisiti, come definiti dalla raccomandazione 2003/361/CE del 6 maggio 2003, pubblicata nella G.U.U.E. n. L 124 del 20 maggio 2003, nell'allegato 1 al <em>regolamento GBER</em> e nel DM 18 aprile 2005, pubblicato nella G.U.R.I. n. 238 del 12 ottobre 2005, di:</span>
            </div>

            <div class="dns-option-row dns-indent">
                <div class="dns-option"><span class="dns-radio"></span>piccola impresa, in tal caso indicare se micro</div>
                <div class="dns-option"><span class="dns-radio"></span>micro impresa</div>
                <div class="dns-option"><span class="dns-radio"></span>media impresa</div>
            </div>

            <div class="dns-in-quanto">in quanto:</div>

            <div class="dns-option dns-option-top">
                <span class="dns-radio" [class.dns-checked]="isAutonomousCompany"></span>
                <span>impresa autonoma, i cui dati nel periodo di riferimento <i class="fa fa-info-circle dns-info"></i> sono i seguenti:</span>
            </div>
            <div class="dns-option dns-option-top">
                <span class="dns-radio" [class.dns-checked]="isAssociatedCompany"></span>
                <span>impresa associata/collegata, secondo quanto previsto nella citata disciplina unionale; i cui dati nel periodo di riferimento <i class="fa fa-info-circle dns-info"></i>, calcolati applicando le modalità di calcolo dei parametri dimensionali indicate nell'appendice al citato decreto ministeriale 18 aprile 2005, come da prospetto allegato <i class="fa fa-info-circle dns-info"></i>, sono i seguenti:</span>
            </div>

            <div class="dns-grid dns-size-data">
                <div class="dns-field">
                    <label class="dns-label dns-label-center">Occupati (ULA <i class="fa fa-info-circle dns-info"></i>)</label>
                    <app-copy-field [value]="customer?.ULALastBalance"></app-copy-field>
                </div>
                <div class="dns-field">
                    <label class="dns-label dns-label-center">Fatturato</label>
                    <app-copy-field [value]="customer?.SalesRevenues"></app-copy-field>
                </div>
                <div class="dns-field">
                    <label class="dns-label dns-label-center">Totale di bilancio</label>
                    <app-copy-field [value]="customer?.TotalAssets"></app-copy-field>
                </div>
            </div>

            <div class="dns-option dns-option-top">
                <span class="dns-check"></span>
                <span>nel caso di superamento, nel periodo di riferimento <i class="fa fa-info-circle dns-info"></i>, delle soglie di effettivi o delle soglie finanziarie definite all'articolo 2 della raccomandazione 2003/361/CE del 6 maggio 2003 relative alla dimensione d'impresa dichiarata, che tale scostamento non ha avuto luogo per due esercizi consecutivi;</span>
            </div>
        </section>

        <!-- Punto 12 -->
        <section class="dns-section">
            <h3 class="dns-title dns-title-center dns-title-caps">Dichiara infine</h3>
            <ul class="dns-declarations">
                <li>
                    di aver assolto, ai sensi del d.P.R. 26 ottobre 1972, n. 642, l'adempimento relativo all'imposta di bollo mediante annullamento e conservazione in originale presso la propria sede o ufficio per eventuali successivi controlli della marca da bollo identificata dal n.
                    <span class="dns-inline-field"><app-copy-field [value]="request?.RevenueStamp"></app-copy-field></span>;
                </li>
                <li>di conoscere ed accettare integralmente il decreto interministeriale 22 aprile 2022 e la circolare n. 410823 del 6 dicembre 2022 e ss. mm. ii.;</li>
                <li>di aver preso visione e di accettare quanto espressamente previsto nella Convenzione (e ss. mm. ii.) stipulata tra il Ministero dello Sviluppo Economico, Cassa depositi e prestiti S.p.a. e Associazione Bancaria Italiana, in relazione alle modalità di messa a disposizione della provvista da parte di Cassa depositi e prestiti S.p.a.;</li>
                <li>di essere consapevole delle responsabilità, anche penali, derivanti dal rilascio di dichiarazioni mendaci e della conseguente decadenza dai benefici concessi sulla base di una dichiarazione non veritiera, ai sensi degli articoli 75 e 76 del D.P.R. 28 dicembre 2000, n. 445;</li>
                <li>di essere informato/a, ai sensi del regolamento (UE) 2016/679 (regolamento europeo in materia di protezione dei dati personali, in sigla GDPR), che i dati personali raccolti saranno trattati, anche con strumenti informatici, esclusivamente nell'ambito del procedimento per il quale la presente dichiarazione viene resa;</li>
                <li>di aver preso visione dell'informativa sul trattamento dei dati personali pubblicata sul sito web del Ministero (www.mise.gov.it) nella pagina dedicata all'intervento agevolativo "Beni strumentali (Nuova Sabatini)" in oggetto;</li>
                <li>di aver reso e sottoscritto la presente dichiarazione, ai sensi degli articoli 47 e 76 del decreto del Presidente della Repubblica 28 dicembre 2000, n. 445, in qualità di procuratore dell'impresa, giusta procura conferita in data dal legale rappresentante.</li>
            </ul>

            <div class="dns-signature">
                <span>Luogo</span>
                <span class="dns-inline-field dns-inline-field-lg"><app-copy-field [value]="signaturePlace"></app-copy-field></span>
                <span>, il {{ today | date: 'dd/MM/yyyy' }}</span>
            </div>
        </section>
    </div>
</div>
